import React from "react";
import PropTypes from "prop-types";
import { useRef, useState, useEffect } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import LoginHeader from "../../components/header/LoginHeader";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";
import InstituteMobileHeader from "../../components/header/InstituteMobileHeader";
import CRMobileHeader from "../../components/header/CRMobileHeader";
import InstituteHeader from "../../components/header/InstituteHeader";
import CRHeader from "../../components/header/CRHeader";
import NonLoginHeader from "../../components/header/NonLoginHeader";
import JobDetails from "./JobDetails";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import { Helmet } from "react-helmet";

JobDetailsMain.propTypes = {};


function JobDetailsMain(props) {
    const progressRef = useRef();
    const [targetHeight, setTargetHeight] = useState(0);
    const [toggle, setToggle] = useState({
        key: "",
        status: false,
    });
    const [isShowMobile, setShowMobile] = useState(false);

    const handleToggle = (key) => {
        if (toggle.key === key) {
            setToggle({
                status: false,
            });
        } else {
            setToggle({
                status: true,
                key,
            });
        }
    };

    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        if (progressRef?.current) {
            const offsetHeight = progressRef?.current?.offsetTop;
            setTargetHeight(offsetHeight);
        }
    }, [progressRef]);

    const module = localStorage.getItem('Module');

    // ...............................Job Details.......................................
    return (
        <>
            <Helmet>
                <title>Jobs | Jobkikhoj</title>
                <meta name="description" content=" " />
                <meta name="keywords" content=" " />
                <meta property="og:title" content="Jobs | Jobkikhoj " />
                <meta property="og:description" content="" />
                <meta property="og:url" content="https://jobkikhoj.com" />
            </Helmet>
            {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
                            <MobileHeader handleMobile={handleMobile} />}
            {module === 'Candidate' ? <LoginHeader handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteHeader handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRHeader handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRHeader handleMobile={handleMobile} /> :
                            <NonLoginHeader handleMobile={handleMobile} />}

            <div className="pt-70">
                <JobDetails />
                <Footer />
                <Gotop />
            </div>
        </>
    );
}

export default JobDetailsMain;

